import React, { Suspense, useEffect, useMemo, useState } from "react";
import "../../../styles/careers/header.scss";
import DefaultCustomMenu from "./CustomMenuTemplates/DefaultCustomMenu";
import CustomMegaMenu from "./CustomMenuTemplates/CustomMegaMenu";
import OptionThreeMegaMenu from "./menuLayouts/OptionThreeMegaMenu";
import Slider from "react-slick";
import useClientConfig from "../../../config/careers/clientConfig";
import { useLocation, useParams } from "react-router-dom";
import { shouldShowSection } from "../utils/commonHelper";
import DooleysBanner from "./clientsMenu/dooleys/DooleysBanner";
import HellersBanner from "./clientsMenu/hellers/HellersBanner";
const ClcBanner = React.lazy(() => import("./clientsMenu/clcouncil/ClcBanner"));
const CvmBanner = React.lazy(() => import("./clientsMenu/cvm/CvmBanner"));
const ManpowerBanner = React.lazy(() => import("./clientsMenu/manpower/ManpowerBanner"));
const TrueitBanner = React.lazy(() => import("./clientsMenu/trueit/TrueitBanner"));
const AssaBanner = React.lazy(() => import("./clientsMenu/assa/AssaBanner"));
const EquityBanner = React.lazy(() => import("./clientsMenu/equity/EquityBanner"));
const AdelaideOvalBanner = React.lazy(() => import("./clientsMenu/adelaideoval/AdelaideOvalBanner"));
const VetsMicroBanner = React.lazy(() => import("./clientsMenu/vets_central/VetsMicroBanner"));
const AnglisseduBanner = React.lazy(() => import("./clientsMenu/anglissedu/AnglisseduBanner"));
const HbsBanner = React.lazy(() => import("./clientsMenu/hbs/HbsBanner"));
const CarbizBanner = React.lazy(() => import("./clientsMenu/carbiz/CarbizBanner"));
const OnestopBanner = React.lazy(() => import("./clientsMenu/onestop/OnestopBanner"));
const AdgceBanner = React.lazy(() => import("./clientsMenu/adgce/AdgceBanner"));
const HalogenBanner = React.lazy(() => import("./clientsMenu/halogen-pools/HalogenBanner"));
const ZfBanner = React.lazy(() => import("./clientsMenu/zf-micro/ZfBanner"));
const MawBanner = React.lazy(() => import("./clientsMenu/makeawish/MakeAWishBanner"));

const CustomHeader = (props: any) => {

    const { clientId, clientSiteSettings } = props;
    const templateName = clientSiteSettings?.templateName;
    const { clientAssetsLink } = useClientConfig();
    const location = useLocation();

    const [menuSettings, setMenuSettings] = useState({
        id: "",
        classref: "",
        logoimg: "",
        moblogoimg: "",
        bannerImg: "",
        bannerImg1: "",
        bannerImg2: "",
        bannerImg3: "",
        artifactImg1: "",
        artifactImg2: "",
        artifactImg3: "",
        copyrightLogo: "",
        footerLogoImg: "",
        menuToggle: "",
        menuType: "1",
        menuToggleClose: "",
        homeLinkHref: ""
    });
    const [count, setCount] = useState(0);

    useEffect(() => {
        let interval: any;
        //Implementing the setInterval method
        if (count <= 6) {
            interval = setInterval(() => {
                setCount((count) => count + 1);
            }, 5000);
        } else {
            clearInterval(interval);
            setCount(0);
        }

        //Clearing the interval
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let currentClientSetting: any = clientSiteSettings?.customMenuUISettings;
        setMenuSettings(currentClientSetting);
    }, [clientSiteSettings]);

    const HeaderComponentName = clientSiteSettings?.headerComponentName;
    const clientFolderName = clientSiteSettings?.clientFolderName;

    const renderMenu = () => {
        switch (templateName) {
            case "template_5": return <DefaultCustomMenu menuSettings={menuSettings} clientId={clientId} />;
            case "template_6": return <DefaultCustomMenu menuSettings={menuSettings} clientId={clientId} />;
            case "template_7": return <CustomMegaMenu menuSettings={menuSettings} clientId={clientId} />;
            case "template_8": return <CustomMegaMenu menuSettings={menuSettings} clientId={clientId} />;
            case "template_9": return <DefaultCustomMenu menuSettings={menuSettings} clientId={clientId} />;
            case "template_10": return <OptionThreeMegaMenu menuSettings={menuSettings} clientId={clientId} />;
            default: return "";
        }
    };

    // this is to find the new clients - start //
    const [isOptionFourClient, setIsOptionFourClient] = useState<boolean>(clientSiteSettings?.optionFourClient);
    const ignoreHeaderRender = ["gre"];

    const isCustom = clientSiteSettings?.customClientOption;
    const folderName = isCustom ? clientSiteSettings?.customClientFolderName : templateName;
    const headerComponentName = isCustom
        ? clientSiteSettings?.headerComponentName
        : `${templateName.charAt(0).toUpperCase()}${templateName.slice(1).replace(/_/g, "")}Header`;

    const LazyClientHeader = useMemo(() => {
        if (!templateName || ignoreHeaderRender.includes(templateName)) {return null;}
        return React.lazy(() =>
            import(`./clientsMenu/${folderName}/${headerComponentName}`).catch(() => ({
                default: () => <div>Not loading....</div>,
            }))
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [folderName, headerComponentName]);

    const renderClientMenu = () => {
        if (!templateName || ignoreHeaderRender.includes(templateName) || !LazyClientHeader) {return null;}
        return (
            <Suspense fallback={<></>}>
                {React.createElement(LazyClientHeader, props)}
            </Suspense>
        );
    };
    // End //

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        arrow: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <>
            <nav className={menuSettings?.classref}>
                {isOptionFourClient ? renderClientMenu() : renderMenu()}
                <div className="body-content" >
                    <div className="container-new">
                        <div className="banner-new">
                            <>
                                {
                                    (clientSiteSettings?.banner === "banner_1") ?
                                        <>
                                            <div className="theme-new-page-id-7-banner">
                                                <img src={process.env.PUBLIC_URL + menuSettings.bannerImg} />
                                                <div className="banner-new-title">A FRESH APPROACH TO BREAKFAST</div>
                                            </div>
                                        </> : ""
                                }
                            </>
                            {
                                (clientSiteSettings?.banner === "banner_8") ? <>
                                    <div className="banner-inner">
                                        <div className="img1">
                                            <img src={process.env.PUBLIC_URL + menuSettings.artifactImg2} />
                                        </div>
                                        <div className="img2">
                                            <img src={process.env.PUBLIC_URL + menuSettings.artifactImg3} />
                                        </div>
                                        <div className="img3">
                                            <img src={process.env.PUBLIC_URL + menuSettings.artifactImg1} />
                                        </div>
                                    </div>
                                </> : ""
                            }
                            {
                                (clientSiteSettings?.banner === "banner_2") ?
                                    <>
                                        <div className="default-option-new-theme-banner">
                                            <div className="banner-img">
                                                <img src={process.env.PUBLIC_URL + menuSettings.bannerImg} />
                                            </div>
                                            <div className="page-title-content">
                                                <div className="animate-text">
                                                    <div className="slider-items">
                                                        <div className={`slide-item ${count === 0 ? "active" : ""}`} data-count="slide-0">
                                                            <p>Next in<br />Workplace Health</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 1 ? "active" : ""}`} data-count="slide-1">
                                                            <p>Next in<br /> Mental Health</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 2 ? "active" : ""}`} data-count="slide-2">
                                                            <p>Next in<br /> Workplace Safety</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 3 ? "active" : ""}`} data-count="slide-3">
                                                            <p>Next in<br /> Team Health</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 4 ? "active" : ""}`} data-count="slide-4">
                                                            <p>Next in<br /> Wellbeing</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 5 ? "active" : ""}`} data-count="slide-5">
                                                            <p>Next in<br /> Prevention</p>
                                                        </div>
                                                        <div className={`slide-item ${count === 6 ? "active" : ""}`} data-count="slide-6">
                                                            <p>Next in<br /> Partnerships</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 className="grey">Transformative workplace
                                                    <br /> health solutions for a safe
                                                    <br /> and well workforce.</h1>
                                            </div>
                                        </div>
                                    </> : ""
                            }

                            {
                                (clientSiteSettings?.banner === "banner_3") ?
                                    <>
                                        <div className="default-option-new-theme-banner default-option-new-theme-banner-micro">
                                            <div className="banner-img">
                                                <img src={process.env.PUBLIC_URL + menuSettings.bannerImg} />
                                            </div>
                                            <div className="page-title-content">
                                                <div className="animate-text">
                                                    <div className="slider-items">
                                                        <div className={`slide-item ${count === 1 ? "active" : "active"}`} data-count="slide-1">
                                                            <p>Next in<br /> workplace flu <br /> vaccinations.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 className="grey">Leave it to us to run large-scale employee flu
                                                    <br /> vaccination programs to protect your employees, cut
                                                    <br /> absenteeism & increase productivity.</h1>
                                            </div>
                                        </div>
                                    </> : ""
                            }
                            {
                                (clientSiteSettings?.banner === "banner_4") ?
                                    <>
                                        <div className="banner-img-section">
                                            <img src={clientAssetsLink + "/banner_home.svg"} alt="" decoding="async" />
                                        </div>
                                    </> : ""
                            }

                            {
                                (clientSiteSettings?.banner === "banner_5") ?
                                    <>
                                        <div className="banner-career-template-new-page-id-1">
                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg} alt="holmesglen" />
                                            <div className="cmp-teaser__content">
                                                <div className="cmp-teaser__pretitle">EXPLORE</div>
                                                <h2 className="cmp-teaser__title"> Open Day Thursday 28 November </h2>
                                                <div className="cmp-teaser__description">
                                                    <p>Hear from our teachers, explore our campuses and facilities, grab a bite to eat at the campus Hub, and see everything we have to offer.</p>
                                                </div>
                                                <div className="cmp-teaser__action-container">
                                                    <a className="cmp-teaser__action-link" href={`${menuSettings?.homeLinkHref}/study-with-us/open-days`} id="teaser-bd9dda1d56-cta-2dc237703f"> <span className="cmp-teaser__action-link-text">Find out more</span> <span className="cmp-teaser__action-link-icon icon-arrow-right"></span> </a>
                                                    <a className="cmp-teaser__action-link" href="tel:1300639888" id="teaser-bd9dda1d56-cta-f9585e4d97"> <span className="cmp-teaser__action-link-text">1300 639 888</span> <span className="cmp-teaser__action-link-icon icon-arrow-right"></span> </a>
                                                </div>
                                            </div>
                                        </div>
                                    </> : ""
                            }

                            {
                                (clientSiteSettings?.banner === "manpower_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><ManpowerBanner /></Suspense>
                                ) : ""
                            }
                            {
                                (clientSiteSettings?.banner === "eco_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><EquityBanner isRegisterPage={location.pathname.includes("/register")} /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "trueit_banner") ? (
                                    <Suspense fallback={<></>}><TrueitBanner /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "anglissedu_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><AnglisseduBanner /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "zf_micro_banner") ? (
                                    <Suspense fallback={<></>}><ZfBanner /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "hbs_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><HbsBanner /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "carbiz_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><CarbizBanner /></Suspense>
                                ) : ""
                            }

                            {
                                (clientSiteSettings?.banner === "adgce_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><AdgceBanner /></Suspense>
                                ) : ""
                            }
                            {
                                (clientSiteSettings?.banner === "halogen_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><HalogenBanner /></Suspense>
                                ) : ""
                            }
                            {
                                (clientSiteSettings?.banner === "maw_Banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><MawBanner /></Suspense>
                                ) : ""
                            }
                            {
                                (clientSiteSettings?.banner === "clc_banner" && shouldShowSection()) ? (
                                    <Suspense fallback={<></>}><ClcBanner /></Suspense>
                                ) : ""
                            }
                            

                            {/* rackley swimming */}
                            {
                                (clientSiteSettings?.banner === "banner_11") &&
                                <>
                                    <div className="elementor-kit-7">
                                        <div data-elementor-type="wp-page" data-elementor-id="8106" className="elementor elementor-8106" data-elementor-post-type="page">
                                            <div className="elementor-element elementor-element-d595e81 home-banner e-flex e-con-boxed e-con e-parent e-lazyloaded" data-id="d595e81" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;shape_divider_bottom&quot;:&quot;wave-brush&quot;}">
                                                <div className="e-con-inner">
                                                    <div className="elementor-shape elementor-shape-bottom" data-negative="false">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.5 27.8" preserveAspectRatio="none">
                                                            <path className="elementor-shape-fill" d="M283.5,9.7c0,0-7.3,4.3-14,4.6c-6.8,0.3-12.6,0-20.9-1.5c-11.3-2-33.1-10.1-44.7-5.7	s-12.1,4.6-18,7.4c-6.6,3.2-20,9.6-36.6,9.3C131.6,23.5,99.5,7.2,86.3,8c-1.4,0.1-6.6,0.8-10.5,2c-3.8,1.2-9.4,3.8-17,4.7	c-3.2,0.4-8.3,1.1-14.2,0.9c-1.5-0.1-6.3-0.4-12-1.6c-5.7-1.2-11-3.1-15.8-3.7C6.5,9.2,0,10.8,0,10.8V0h283.5V9.7z M260.8,11.3	c-0.7-1-2-0.4-4.3-0.4c-2.3,0-6.1-1.2-5.8-1.1c0.3,0.1,3.1,1.5,6,1.9C259.7,12.2,261.4,12.3,260.8,11.3z M242.4,8.6	c0,0-2.4-0.2-5.6-0.9c-3.2-0.8-10.3-2.8-15.1-3.5c-8.2-1.1-15.8,0-15.1,0.1c0.8,0.1,9.6-0.6,17.6,1.1c3.3,0.7,9.3,2.2,12.4,2.7	C239.9,8.7,242.4,8.6,242.4,8.6z M185.2,8.5c1.7-0.7-13.3,4.7-18.5,6.1c-2.1,0.6-6.2,1.6-10,2c-3.9,0.4-8.9,0.4-8.8,0.5	c0,0.2,5.8,0.8,11.2,0c5.4-0.8,5.2-1.1,7.6-1.6C170.5,14.7,183.5,9.2,185.2,8.5z M199.1,6.9c0.2,0-0.8-0.4-4.8,1.1	c-4,1.5-6.7,3.5-6.9,3.7c-0.2,0.1,3.5-1.8,6.6-3C197,7.5,199,6.9,199.1,6.9z M283,6c-0.1,0.1-1.9,1.1-4.8,2.5s-6.9,2.8-6.7,2.7	c0.2,0,3.5-0.6,7.4-2.5C282.8,6.8,283.1,5.9,283,6z M31.3,11.6c0.1-0.2-1.9-0.2-4.5-1.2s-5.4-1.6-7.8-2C15,7.6,7.3,8.5,7.7,8.6	C8,8.7,15.9,8.3,20.2,9.3c2.2,0.5,2.4,0.5,5.7,1.6S31.2,11.9,31.3,11.6z M73,9.2c0.4-0.1,3.5-1.6,8.4-2.6c4.9-1.1,8.9-0.5,8.9-0.8	c0-0.3-1-0.9-6.2-0.3S72.6,9.3,73,9.2z M71.6,6.7C71.8,6.8,75,5.4,77.3,5c2.3-0.3,1.9-0.5,1.9-0.6c0-0.1-1.1-0.2-2.7,0.2	C74.8,5.1,71.4,6.6,71.6,6.7z M93.6,4.4c0.1,0.2,3.5,0.8,5.6,1.8c2.1,1,1.8,0.6,1.9,0.5c0.1-0.1-0.8-0.8-2.4-1.3	C97.1,4.8,93.5,4.2,93.6,4.4z M65.4,11.1c-0.1,0.3,0.3,0.5,1.9-0.2s2.6-1.3,2.2-1.2s-0.9,0.4-2.5,0.8C65.3,10.9,65.5,10.8,65.4,11.1	z M34.5,12.4c-0.2,0,2.1,0.8,3.3,0.9c1.2,0.1,2,0.1,2-0.2c0-0.3-0.1-0.5-1.6-0.4C36.6,12.8,34.7,12.4,34.5,12.4z M152.2,21.1	c-0.1,0.1-2.4-0.3-7.5-0.3c-5,0-13.6-2.4-17.2-3.5c-3.6-1.1,10,3.9,16.5,4.1C150.5,21.6,152.3,21,152.2,21.1z"></path>
                                                            <path className="elementor-shape-fill" d="M269.6,18c-0.1-0.1-4.6,0.3-7.2,0c-7.3-0.7-17-3.2-16.6-2.9c0.4,0.3,13.7,3.1,17,3.3	C267.7,18.8,269.7,18,269.6,18z"></path>
                                                            <path className="elementor-shape-fill" d="M227.4,9.8c-0.2-0.1-4.5-1-9.5-1.2c-5-0.2-12.7,0.6-12.3,0.5c0.3-0.1,5.9-1.8,13.3-1.2	S227.6,9.9,227.4,9.8z"></path>
                                                            <path className="elementor-shape-fill" d="M204.5,13.4c-0.1-0.1,2-1,3.2-1.1c1.2-0.1,2,0,2,0.3c0,0.3-0.1,0.5-1.6,0.4	C206.4,12.9,204.6,13.5,204.5,13.4z"></path>
                                                            <path className="elementor-shape-fill" d="M201,10.6c0-0.1-4.4,1.2-6.3,2.2c-1.9,0.9-6.2,3.1-6.1,3.1c0.1,0.1,4.2-1.6,6.3-2.6	S201,10.7,201,10.6z"></path>
                                                            <path className="elementor-shape-fill" d="M154.5,26.7c-0.1-0.1-4.6,0.3-7.2,0c-7.3-0.7-17-3.2-16.6-2.9c0.4,0.3,13.7,3.1,17,3.3	C152.6,27.5,154.6,26.8,154.5,26.7z"></path>
                                                            <path className="elementor-shape-fill" d="M41.9,19.3c0,0,1.2-0.3,2.9-0.1c1.7,0.2,5.8,0.9,8.2,0.7c4.2-0.4,7.4-2.7,7-2.6	c-0.4,0-4.3,2.2-8.6,1.9c-1.8-0.1-5.1-0.5-6.7-0.4S41.9,19.3,41.9,19.3z"></path>
                                                            <path className="elementor-shape-fill" d="M75.5,12.6c0.2,0.1,2-0.8,4.3-1.1c2.3-0.2,2.1-0.3,2.1-0.5c0-0.1-1.8-0.4-3.4,0	C76.9,11.5,75.3,12.5,75.5,12.6z"></path>
                                                            <path className="elementor-shape-fill" d="M15.6,13.2c0-0.1,4.3,0,6.7,0.5c2.4,0.5,5,1.9,5,2c0,0.1-2.7-0.8-5.1-1.4	C19.9,13.7,15.7,13.3,15.6,13.2z"></path>
                                                        </svg>		</div>
                                                    <div className="elementor-element elementor-element-9a3fca9 e-con-full e-flex e-con e-child" data-id="9a3fca9" data-element_type="container">
                                                        <div className="elementor-element elementor-element-5706fee e-con-full e-flex e-con e-child" data-id="5706fee" data-element_type="container">
                                                            <div className="elementor-element elementor-element-5b642b2 pa-display-conditions-yes elementor-widget elementor-widget-heading" data-id="5b642b2" data-element_type="widget" data-settings="{&quot;pa_display_conditions_switcher&quot;:&quot;yes&quot;}" data-widget_type="heading.default">
                                                                <div className="elementor-widget-container">
                                                                    <h1 className="elementor-heading-title elementor-size-default">Become a swim teacher</h1></div>
                                                            </div>
                                                        </div>
                                                        <div className="elementor-element elementor-element-5e53096 e-con-full e-flex e-con e-child" data-id="5e53096" data-element_type="container">
                                                            <div className="elementor-element elementor-element-378426c dce_masking-none elementor-widget elementor-widget-image" data-id="378426c" data-element_type="widget" data-widget_type="image.default">
                                                                <div className="elementor-widget-container">
                                                                    <div className="elementor-widget-container img-wrapper">
                                                                        <img src={clientAssetsLink + "/SchoolSwimmingImage.webp"} alt="Banner Image" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                (clientSiteSettings?.banner === "banner_7") ?
                                    <>
                                        <div className="default-option-new-theme-banner default-option-new-theme-banner-micro">

                                            <div>
                                                <div className="animate-text">
                                                    <div className="slider-items">
                                                        <div className={`slide-item ${count === 0 ? "active" : ""}`} data-count="slide-0">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg1} />
                                                        </div>
                                                        <div className={`slide-item ${count === 1 ? "active" : ""}`} data-count="slide-1">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg2} />
                                                        </div>
                                                        <div className={`slide-item ${count === 2 ? "active" : ""}`} data-count="slide-2">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg3} />
                                                        </div>

                                                        <div className={`slide-item ${count === 3 ? "active" : ""}`} data-count="slide-3">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg1} />
                                                        </div>
                                                        <div className={`slide-item ${count === 4 ? "active" : ""}`} data-count="slide-4">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg2} />
                                                        </div>
                                                        <div className={`slide-item ${count === 5 ? "active" : ""}`} data-count="slide-5">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg3} />
                                                        </div>

                                                        <div className={`slide-item ${count === 6 ? "active" : ""}`} data-count="slide-6">
                                                            <img src={process.env.PUBLIC_URL + menuSettings.bannerImg2} />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    : ""
                            }
                            {
                                //hide banner on apply job page - turbo
                                (clientSiteSettings?.banner === "turbo_banner" && shouldShowSection()) ?
                                    <>
                                        <main className="site-main" id="primary">
                                            <div className="hero-banner">
                                                <div className="wrapper">
                                                    <div className="banner-bg">
                                                        <img src={clientAssetsLink + "/hero-banner-xl.svg"} alt="" />
                                                    </div>
                                                    <div className="banner-holder">
                                                        <div className="banner-text">
                                                            <div className="text-holder">
                                                                <strong className="banner-title animate__animated animate__fadeInUp">Better applicant tracking:</strong>
                                                                <span className="banner-subtitle animate__animated animate__fadeInUp">Recruit with confidence.</span>
                                                            </div>

                                                        </div>
                                                        <div className="hero-img">
                                                            <div className="img">
                                                                <img src={clientAssetsLink + "/office-banner.png"} alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </main>
                                    </>
                                    : ""
                            }
                            {
                                //hide banner on apply job page - turbo
                                (clientSiteSettings?.banner === "adelaideoval_banner" && shouldShowSection()) ?
                                    <Suspense fallback={<></>}><AdelaideOvalBanner /></Suspense>
                                    : ""
                            }
                            {
                                //hide banner on apply job page - qimr
                                (clientSiteSettings?.banner === "qimr_banner" && shouldShowSection()) ?
                                    <>
                                        <div className="qimr">
                                            <section id="pageSummary" className="relative bg-transparent container mx-auto flex justify-center mt-header px-0 md:mb-12 md:mt-36 md:px-6">
                                                <div className="w-full">
                                                    <div className="relative flex rounded-3xl flex-col w-full border-silver25/60 bg-white text-silver75 md:border h-full rounded-none md:rounded-3xl">
                                                        <div className="flex gap-8 p-6 md:flex-row md:p-4 min-h-[37rem] flex-col">
                                                            <div className="flex flex-col md:w-1/2">
                                                                <div className="mt-4 pl-4 md:pl-10">
                                                                    <div className="w-full truncate"><a className="inline text-breadcrumb" href="https://www.qimrb.edu.au">Home</a></div>
                                                                </div>
                                                                <div className="flex h-full flex-col md:px-8 pb-2">
                                                                    <div className="flex h-full flex-col justify-center gap-6">
                                                                        <div className="relative">
                                                                            <h1 className="font-semibold text-summary-title-md text-poppy75">Our People and Careers</h1>
                                                                        </div>
                                                                        <p className="font-serif font-normal text-lead-lg">Explore the possibilities that await you at QIMR Berghofer. Your journey to making a difference starts here.</p>
                                                                    </div>
                                                                </div>
                                                                <div className="my-8 flex flex-col gap-4 md:ml-8 md:flex-row md:items-center"></div>
                                                            </div>
                                                            <div className="relative h-full w-full md:aspect-auto md:w-1/2 aspect-[3/2]">
                                                                <div className="bg-light w-full rounded-3xl overflow-hidden absolute left-0 top-0 right-0 bottom-0">
                                                                    <img src={clientAssetsLink + "/qimr-photoshoot-selects-013a7718.webp"} alt="career" className="w-full h-full object-cover" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </>
                                    : ""
                            }
                            {
                                //Assa banner
                                (clientSiteSettings?.banner === "assa_banner" && shouldShowSection()) ?
                                    <Suspense fallback={<></>}><AssaBanner /></Suspense>
                                    : ""
                            }
                            {
                                //vets micro banner
                                (clientSiteSettings?.banner === "vets_micro_banner") ?
                                    <Suspense fallback={<></>}><VetsMicroBanner /></Suspense>
                                    : ""
                            }
                            {
                                (templateName === "template_23") &&
                                <>
                                    <Slider {...settings}>
                                        <div className={`slide-item ${count === 0 ? "active" : ""}`} data-count="slide-0">
                                            <img src={clientAssetsLink + "/banner1.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 1 ? "active" : ""}`} data-count="slide-1">
                                            <img src={clientAssetsLink + "/banner2.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 2 ? "active" : ""}`} data-count="slide-2">
                                            <img src={clientAssetsLink + "/banner3.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 3 ? "active" : ""}`} data-count="slide-3">
                                            <img src={clientAssetsLink + "/banner1.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 4 ? "active" : ""}`} data-count="slide-4">
                                            <img src={clientAssetsLink + "/banner2.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 5 ? "active" : ""}`} data-count="slide-5">
                                            <img src={clientAssetsLink + "/banner3.jfif"} />
                                        </div>
                                        <div className={`slide-item ${count === 6 ? "active" : ""}`} data-count="slide-6">
                                            <img src={clientAssetsLink + "/banner2.jfif"} />
                                        </div>
                                    </Slider>
                                </>
                            }

                            {
                                (clientSiteSettings?.banner === "cvm_banner" && shouldShowSection() &&
                                  !(clientSiteSettings?.hasCultureLandingPage && location.pathname === "/")) &&
                                <Suspense fallback={<></>}><CvmBanner /></Suspense>
                            }

                            {
                                (templateName === "template_21") &&
                                <>
                                    <div className="indexblock">
                                        <img src={clientAssetsLink + "/banner.png"} className="img-banner" />
                                        <div className="standard-page__body">
                                            <div className="container pt-4 pt-sm-5 pb-3">
                                                <article role="article">
                                                    <h1 role="heading" aria-level={1} className="text-primary sr-only">Careers</h1>
                                                    <div className="content typography">
                                                        <h3>For fresh fish!</h3>
                                                        <p>You may have read that we’re very welcoming at Fish N Flips. And we look for people who have that same attitude. You know, people who make every day a fun experience and embrace every opportunity. We call them fresh fish. Your brilliant attitude, passion for fun and dedication to helping children develop life-saving skills is just what we’re looking for.</p>
                                                        <h3>Let’s get learning</h3>
                                                        <p>We know you’re a catch. If you join us, we’ll show our appreciation by giving you some great perks and benefits. Oh, and we’ll give you all the training you need, so you know exactly what you’re doing at all times. And if you’re not having fun, then we’re not doing our best!</p>
                                                        <h3>We’re better together</h3>
                                                        <p>We respect everyone, regardless of their beliefs, gender, identity or culture. So if we sound like somewhere you’d love to work, we’d love to hear from you!</p>
                                                    </div>
                                                </article>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                (clientSiteSettings?.banner === "onestop_banner") &&
                                <Suspense fallback={<></>}><OnestopBanner /></Suspense>
                            }
                            {
                                (templateName === "template_28") &&
                                <>
                                    <div className="page-content" id="page-content" style={{ marginTop: 70 }}>
                                        <section className="breadcrumb-block">
                                            <div className="container">
                                                <ul className="breadcrumb">
                                                    <li className="breadcrumb-item">
                                                        <div className="svg-icon-wrapper breadcrumb-item-icon">
                                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z" fill="currentColor" />
                                                            </svg>
                                                        </div>
                                                        <a className="breadcrumb-item-link" target="_blank" rel="noreferrer nofollow" href="/">
                                                            <div className="svg-icon-wrapper">
                                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.3861 1.21065C11.7472 0.929784 12.2528 0.929784 12.6139 1.21065L21.6139 8.21065C21.8575 8.4001 22 8.69141 22 9V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V9C2 8.69141 2.14247 8.4001 2.38606 8.21065L11.3861 1.21065ZM4 9.48908V20C4 20.2652 4.10536 20.5196 4.29289 20.7071C4.48043 20.8946 4.73478 21 5 21H19C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V9.48908L12 3.26686L4 9.48908Z" fill="currentColor" />
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V13H10V22C10 22.5523 9.55228 23 9 23C8.44772 23 8 22.5523 8 22V12Z" fill="currentColor" />
                                                                </svg>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li className="breadcrumb-item active-breadcrumb-item">
                                                        <div className="svg-icon-wrapper breadcrumb-item-icon">
                                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z" fill="currentColor" />
                                                            </svg>
                                                        </div>
                                                        Careers
                                                    </li>
                                                </ul>
                                            </div>
                                        </section>
                                        <div>
                                            <section className="hero-banner-block use-theme">
                                                <div className="hero-banner">
                                                    <div className="image-wrapper hrbn-image-container curved-bottom custom-hero-banner">
                                                        <figure>
                                                            <picture> <img src={clientAssetsLink + "/hero_Careers.jpg"} alt="" decoding="async" width={800} height={500} /> </picture>
                                                        </figure>
                                                    </div>
                                                    <div className="container">
                                                        <div className="hrbn-copy">
                                                            <h1 className="hrbn-title">Careers</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="hero-banner-text-content ">
                                                    <div className="container">
                                                        <div className="hbt-anchors-container no-page-anchor" />
                                                        <div className="hbt-mobile-anchors-container no-page-anchor">
                                                            <div className="form-element  hbt-mobile-anchor-select element-size-md">
                                                                <label htmlFor="page-anchors" className="sr-only"> page-anchors <span className="form-optional">(optional)</span> </label>
                                                                <div className="element-wrapper  has-suffix-icon">
                                                                    <select id="page-anchors">
                                                                        <option value="" > Jump to </option>
                                                                    </select>
                                                                    <div className="svg-icon-wrapper suffix-icon">
                                                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="currentColor" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className="hbt-section-separator no-page-anchor" />
                                                    <div className="container">
                                                        <div className="hbt-text-content-wrapper">
                                                            <h3 className="hbt-subheading"> Whatever you do, with us you&apos;ll make a difference every day. </h3>
                                                            <div className="hbt-desc"> With almost 4000 employees and 600 volunteers working across 100 communities, we&apos;re a large not-for-profit with many different career opportunities across dozens of professions. We employ people from all different backgrounds and beliefs, but what we all do have in common is our desire to help others in line with our values of unconditional love, continual innovation, mutual trust, wise stewardship and safety. We work across aged care, retirement living, foster care, youth support and family support services - and much more. From carers and nurses, to cooks, gardeners, youth workers, lawyers, IT professionals and tradespeople, we have a variety of roles for people who are passionate about making a positive difference every day. </div>
                                                            <div className="hbt-buttons-container">
                                                                <a target="_blank" rel="noreferrer nofollow" href="/careers/current-vacancies/" className="btn btn-skin-1 btn-size-md hbt-button">
                                                                    <span className="btn-text"> Current vacancies or opportunities </span>
                                                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z" fill="currentColor" />
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M15.9429 15.9429C16.3334 15.5524 16.9666 15.5524 17.3571 15.9429L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L15.9429 17.3571C15.5524 16.9666 15.5524 16.3334 15.9429 15.9429Z" fill="currentColor" />
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                (clientSiteSettings?.banner === "tmha_banner") &&
                                <>
                                    <div className="body-inner font-reset">
                                        <section className="hero hero--overlay hero--nav-spacing has-section-divider-bottom hero-banner--generic hero-banner--static banner-style">
                                            <div className="container position-relative text-center">
                                                <div className="hero__text color-white chome">
                                                    <h1>ARE YOU MADE FOR MORE?</h1>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </>
                            }

                            {
                                (templateName === "dooleys") && <DooleysBanner />
                            }

                            {
                                (templateName === "hellers") && <HellersBanner />
                            }

                            {
                                (clientSiteSettings?.banner === "SanitariumMicroBanner") &&
                                <>
                                    <div className="center bnr-img">
                                        <img src={clientAssetsLink + "/banner.png"} />
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default React.memo(CustomHeader);